import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import './Light_Black_Btn.css'

const Light_Black_Btn = ({ btnText, onClick }) => {
    return (
        <section className="Light_Black_Btn_holder">
            <Button className="Light_Black_Btn" onClick={onClick}>{btnText}</Button>
        </section>

    )
}

export default Light_Black_Btn
